module.exports = __webpack_public_path__ + "media/static/icons/icon-sandbar--red-0b4963c604fee95d89f4ac5817fe1c7d.svg";